import { Component, OnInit } from '@angular/core';

interface FAQ {
  id: number;
  question: string;
  answer: string;
  category: string;
  isPremium: boolean;
}


@Component({
  selector: 'app-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.css']
})
export class FaqListComponent implements OnInit {

  ngOnInit(): void {
  }

  searchTerm = '';
  selectedCategory = 'all';

  isLoggedIn = true; // Replace with actual login check
  hasPremium = false; // Replace with actual premium check

  faqs: FAQ[] = [
    {
      id: 1,
      question: '¿Me pueden ayudar con la renovación del seguro privado de salud?',
      answer: 'Claro, te podemos ayudar con el proceso de renovación. Si estás asegurada con ASISA o cualquier otro proveedor, te guiaremos en los pasos necesarios para extender tu cobertura.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 2,
      question: '¿Qué información necesitan para ayudarme con la renovación?',
      answer: 'Necesitamos tu nombre completo, ambos apellidos y un correo electrónico para ponernos en contacto contigo. Además, para ASISA requerimos la carta de admisión de la universidad (aunque sea del año anterior) para iniciar el trámite.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 3,
      question: '¿Cuándo debe empezar la cobertura del seguro?',
      answer: 'Las pólizas de seguro siempre deben comenzar el 1° de cada mes, sin importar cuándo vence tu seguro actual.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 4,
      question: '¿Puedo extender mi seguro por un año completo?',
      answer: 'Sí, podemos extender tu cobertura de seguro por un año completo, desde el 1° de octubre hasta el 30 de septiembre del siguiente año.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 5,
      question: '¿Cuáles son los pasos que debo seguir para extender mi seguro?',
      answer: 'Envíanos los documentos requeridos (por ejemplo, la carta de admisión de la universidad) y nos encargamos del resto. Te confirmaremos si la carta es válida y, a partir de ahí, deberás seguir los pasos detallados en el correo que te enviemos con la cotización y el proceso de pago por nuestros servicios.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 6,
      question: '¿Qué pasa si ya no estoy estudiando pero igual necesito cobertura?',
      answer: 'Si ya no eres estudiante pero necesitas cobertura por unos meses más, podrías optar por una póliza de seguro para residentes. Sin embargo, esta opción suele ser más costosa, ya que los descuentos para estudiantes no aplican.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 7,
      question: '¿Qué puedo hacer si la póliza de residente es muy cara?',
      answer: 'Podrías considerar aplicar al seguro público, ya que podría ser una opción más económica. Si necesitas la cotización del seguro privado, también te podemos ayudar con eso.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 8,
      question: '¿Qué hago si no consigo la documentación necesaria para el seguro de estudiante?',
      answer: 'Si no vas a continuar con tus estudios y no tienes prueba de matrícula para el nuevo año académico, podemos ayudarte a solicitar una póliza de seguro para residentes. Recuerda que esta opción es más costosa que el seguro para estudiantes.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 9,
      question: '¿Qué es una correduría de seguros en España?',
      answer: 'Una correduría de seguros es una empresa que actúa como intermediaria entre las compañías aseguradoras y los clientes. Su principal función es asesorar al cliente para contratar pólizas que se adapten a sus necesidades y gestionar todo el proceso relacionado con la contratación y mantenimiento del seguro.',
      category: 'Información General',
      isPremium: true
    },
    {
      id: 10,
      question: '¿En qué se diferencia una correduría de un agente de seguros?',
      answer: 'A diferencia de los agentes de seguros, que suelen representar a una sola compañía, las corredurías trabajan con múltiples aseguradoras. Esto les permite ofrecer una gama más amplia de productos y comparar entre diferentes opciones para encontrar la mejor para el cliente.',
      category: 'Información General',
      isPremium: true
    },
    {
      id: 11,
      question: '¿Qué servicios ofrece una correduría de seguros?',
      answer: 'Además de ayudarte a contratar una póliza, una correduría gestiona siniestros, reclamaciones y hace seguimiento de tu seguro. Se encargan de actuar como intermediarios con la aseguradora para que el proceso sea más sencillo y beneficioso para ti.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 12,
      question: '¿Quién regula las corredurías de seguros en España?',
      answer: 'En España, las corredurías de seguros están reguladas por la Dirección General de Seguros y Fondos de Pensiones (DGSFP), que supervisa su actividad y asegura que cumplan con la normativa vigente, operando con transparencia y ética.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 13,
      question: '¿Cuáles son los beneficios de usar una correduría de seguros?',
      answer: 'Los clientes se benefician del conocimiento especializado de los corredores, acceden a una variedad más amplia de productos y pueden conseguir mejores condiciones gracias a la capacidad de la correduría para negociar con diferentes aseguradoras.',
      category: 'Seguro',
      isPremium: true
    },
    {
      id: 14,
      question: '¿Qué tan recomendable es visitar la Ribera del Duero si nos gusta el vino?',
      answer: `La Ribera del Duero es una de las regiones vinícolas más reconocidas de España, famosa por sus vinos tintos, especialmente el tempranillo. Además de disfrutar de catas de vino en bodegas prestigiosas, pueden explorar castillos medievales, disfrutar de gastronomía local y paisajes impresionantes. Si son amantes del vino, es una parada obligatoria. Además, en los meses de otoño e invierno, el turismo en la zona es menos concurrido, lo que ofrece una experiencia más tranquila y personalizada.
    Consejo adicional: Para complementar la experiencia, considera visitar bodegas como Vega Sicilia o Pago de los Capellanes, que son conocidas a nivel internacional.`,
      category: 'Viajes',
      isPremium: true
    },
    {
      id: 15,
      question: '¿Es buena idea viajar a Escocia en invierno? ¿Qué debo tener en cuenta?',
      answer: `Escocia es un destino impresionante con paisajes de ensueño, castillos históricos y ciudades vibrantes como Edimburgo y Glasgow. Sin embargo, el clima en invierno (diciembre a febrero) puede ser muy frío, con temperaturas que varían entre 0°C y 7°C, y frecuentes lluvias y nieve. Si les encanta el frío y no les importa la lluvia, Escocia ofrece experiencias como recorrer el Lago Ness, explorar las Tierras Altas (Highlands) y visitar castillos como el de Stirling.
    Consejo adicional: Si viajan en invierno, asegúrense de llevar ropa adecuada para el frío y la lluvia, y planifiquen actividades de interior, como visitar museos, destilerías de whisky o realizar tours de castillos.`,
      category: 'Viajes',
      isPremium: true
    },
    {
      id: 16,
      question: '¿Es Dublín una buena opción para incluir en nuestro itinerario?',
      answer: `Dublín, la capital de Irlanda, es una ciudad rica en historia y cultura. Entre los principales puntos de interés se encuentran el Trinity College (hogar del famoso "Book of Kells"), la fábrica de Guinness, y la vibrante vida nocturna en el barrio de Temple Bar. Aunque es una ciudad pequeña en comparación con otras capitales europeas, ofrece mucho en términos de cultura, literatura y música. El invierno en Dublín es frío y lluvioso, con temperaturas promedio de entre 2°C y 8°C.
    Consejo adicional: Si les gusta la historia y el folclore, podrían disfrutar de tours que exploran la mitología celta y las antiguas tradiciones irlandesas.`,
      category: 'Viajes',
      isPremium: true
    },
    {
      id: 17,
      question: '¿Cuál es la mejor manera de organizar un viaje que incluya Escocia, Dublín y Stonehenge en el mismo recorrido?',
      answer: `Escocia, Dublín y Stonehenge son destinos icónicos en Europa, pero requieren una planificación logística cuidadosa debido a la distancia entre ellos. La mejor forma de organizar un viaje que incluya estos tres lugares es comenzar en un país y aprovechar los vuelos económicos entre Irlanda y el Reino Unido. Por ejemplo:
    - Día 1-3: Ribera del Duero (España) para disfrutar del vino.
    - Día 4-7: Escocia (Edimburgo y las Highlands).
    - Día 8-10: Dublín (Irlanda).
    - Día 11: Stonehenge (Reino Unido, cerca de Londres).
    Consejo adicional: Reserven vuelos con aerolíneas de bajo costo como Ryanair o EasyJet para ahorrar en el transporte entre estos destinos.`,
      category: 'Viajes',
      isPremium: true
    },
    {
      id: 18,
      question: '¿España es más asequible que Escocia o Dublín?',
      answer: `En términos generales, España es más asequible que Escocia y Dublín, especialmente en lo que se refiere a alojamiento, comida y transporte. Ciudades como Madrid, Sevilla o Bilbao ofrecen una excelente relación calidad-precio para los turistas. En comparación, tanto Escocia como Dublín tienden a ser más caros, con un costo de vida más alto y tarifas turísticas más elevadas, especialmente en temporada alta.
    Consejo adicional: Si buscan opciones más económicas en Escocia, podrían alojarse en pueblos más pequeños fuera de Edimburgo, y en Dublín pueden optar por alojamientos tipo bed & breakfast.`,
      category: 'Viajes',
      isPremium: true
    },
    {
      id: 19,
      question: '¿Qué otros destinos en España podríamos considerar además de la Ribera del Duero?',
      answer: `España tiene una gran variedad de destinos que pueden adaptarse a diferentes gustos y presupuestos. Además de la Ribera del Duero, pueden considerar:
    - Sevilla: Una ciudad llena de cultura, con flamenco, tapas y la majestuosa Catedral de Sevilla.
    - Granada: Para una visita a la Alhambra, uno de los palacios más impresionantes de Europa.
    - San Sebastián: Para disfrutar de la playa y de la alta gastronomía.
    - La Rioja: Otra región vinícola famosa, menos concurrida que Ribera del Duero, pero igualmente espectacular.
    Consejo adicional: Si son amantes del senderismo, pueden explorar los Picos de Europa o visitar las Islas Canarias, que ofrecen buen clima incluso en invierno.`,
      category: 'Viajes',
      isPremium: true
    },
    {
      id: 20,
      question: '¿Qué debo considerar al planear viajes de invierno por Europa?',
      answer: `Viajar por Europa en invierno puede ser encantador, pero requiere preparación:
    - Clima: Revisen el pronóstico. Ropa térmica, impermeables y buen calzado son esenciales.
    - Presupuesto: Navidad y Año Nuevo son más caros, especialmente en Dublín y Escocia. Reservar con antelación puede ahorrar dinero.
    - Transporte: Consideren trenes y aerolíneas de bajo costo como Ryanair o EasyJet para moverse entre países. Los trenes en Europa son cómodos y puntuales.`,
      category: 'Viajes',
      isPremium: true
    }
  ];

  get categories(): string[] {
    return ['all', ...Array.from(new Set(this.faqs.map(f => f.category)))];
  }

  get filteredFaqs(): FAQ[] {
    const term = this.searchTerm.toLowerCase();
    return this.faqs.filter(faq =>
      (this.selectedCategory === 'all' || faq.category === this.selectedCategory) &&
      (faq.question.toLowerCase().includes(term) || faq.answer.toLowerCase().includes(term))
    );
  }
  
}
